import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _AmortizationType, _PayrollEntity, _single } from '../../../../core/services/dataBean/EntityCatalog';
import { _LoanLine } from '../../../../core/services/dataBean/EntityCatalogVdos';

interface Props {
    idSelector: number;
    onChange: (value: any) => void;
    label?: string;
    returnType?: "ID" | "Object";
}

export const PayrollEntitySelect = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {

    const { instance } = useDataBean(_PayrollEntity);
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState<number>(null);

    useEffect(() => {
        setID(idSelector);
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        const selectedID = parseInt(e);
        setID(selectedID);

        if (returnType === "Object") {
            const selectedItem = lista.find(
                (item: any) => item.DataBeanProperties.IDPayrollEntity === selectedID
            );
            onChange(selectedItem.DataBeanProperties ?? null); 
        } else {
            onChange(selectedID);
        }
    };



    const getLista = () => {

        let data = _single.getSessionItem("PayrollEntityCatalog");
        if (data) {
            setLista(JSON.parse(data));
        } else {
            instance.getPayrollEntityCatalog(null).then(
                (resp) => {
                    setLista(resp);
                    _single.setSessionItem("PayrollEntityCatalog", JSON.stringify(resp));
                }
            ).catch(
                err => { console.log(err) }
            )

        }

    }

    return (
        <>
            <label>{label ?? "Caja Nominadora"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDPayrollEntity} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}